// Tab-separated representation for copy/paste of a 96 × N volume matrix.
// 96 lines, each with N numeric values. No header.

export function volumesToTsv(volumes: number[][]): string {
  return volumes.map((row) => row.map((n) => formatNum(n)).join("\t")).join("\n");
}

function formatNum(n: number): string {
  if (!Number.isFinite(n)) return "0";
  // Trim trailing zeros, allow up to 4 decimals.
  const fixed = n.toFixed(4);
  return fixed.replace(/\.?0+$/, "");
}

export interface TsvParseResult {
  volumes: number[][];
  warnings: string[];
}

export function parseTsv(input: string, expectedCols: number): TsvParseResult {
  const warnings: string[] = [];
  const lines = input.replace(/\r\n?/g, "\n").split("\n").filter((l) => l.length > 0);
  if (lines.length !== 96) {
    throw new Error(`expected 96 lines, got ${lines.length}`);
  }
  const volumes: number[][] = [];
  for (let i = 0; i < 96; i++) {
    const cells = lines[i]!.split("\t");
    if (cells.length !== expectedCols) {
      throw new Error(
        `line ${i + 1}: expected ${expectedCols} columns, got ${cells.length}`
      );
    }
    const row = cells.map((c, k) => {
      const trimmed = c.trim().replace(",", ".");
      if (trimmed === "") return 0;
      const n = Number(trimmed);
      if (!Number.isFinite(n)) {
        warnings.push(`line ${i + 1} col ${k + 1}: bad value "${c}" → 0`);
        return 0;
      }
      return n;
    });
    volumes.push(row);
  }
  return { volumes, warnings };
}
